module.exports = __webpack_public_path__ + "static/media/edit_black_24dp.201e6431.svg";